<template>
    <layout name="LayoutDefault">
        <div class="About">
            <!-- Page Content -->
            <div class="container">
                <!-- Page Features -->
                <div class="contents">
                    <div class="row">
                        <div class="col-lg-12 text-justify gallery">
                            <p v-if="isLoading">loading...</p>
                            <div class="row">
                                <div class="col-lg-4" v-for="(image, i) in galleryData">
                                    <div class="image">
                                        <img :src="`${IMAGEURL}${image.image}`" :data-image="image.image" @click="toggleModal(image.image, image.title, i)" :data-title="`${image.title}`" :class="`img-${i}`">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- /.container -->
            <div class="js-modal gallery-modal">
                <div class="modal-content" style="width: 1140px;    max-height: 100%;">
                    <span class="close-button" @click="closeModal">×</span>
                    <div style="position: relative; text-align: center; overflow: auto;">
                        <i class="fa fa-chevron-left prev next-prev-btn" v-if="activeSl > 0" @click="galleryNextPrev('prev')" title="Previous"></i>
                        <i class="fa fa-chevron-right next next-prev-btn" v-if="activeSl < totalImage-1" @click="galleryNextPrev('next')" title="Next"></i>
                        <img v-if="photoSelected" v-bind:src="`${IMAGEURL}${photoSelected}`" class="img-responsive">
                        <h3 class="mt-2 text-center" v-if="photoTitle">{{photoTitle}}</h3>
                    </div>
                </div>
            </div>
        </div>
    </layout>
</template>

<script>
    import Layout from '../layouts/Layout';

    export default {
        name: `Home`,
        data() {
            return {
                isLoading: true,
                galleryData: [],
                images: [],
                photoSelected: null,
                photoTitle: null,
                index: null,
                activeSl: null,
                totalImage: null,
            }
        },
        components: {
            Layout,
        },
        methods: {
            getGallery() {
                fetch(this.APIURL + 'cms-resources/Gallery')
                    .then(response => response.json())
                    .then(json => {
                        this.galleryData = json.data;
                        this.isLoading = false;
                        this.totalImage = this.galleryData.length;
                    })
            },
            toggleModal(photo, title, sl) {
                this.photoSelected = photo;
                this.photoTitle = title;
                this.activeSl = sl;
                var modal = document.querySelector(".gallery-modal");
                modal.classList.toggle("show-modal");
            },
            galleryNextPrev(type) {
                if(type == 'next'){
                    var sl = this.activeSl + 1;
                }else{
                    var sl = this.activeSl - 1;
                }

                var image = $(".img-"+sl).data('image');
                var title = $(".img-"+sl).data('title');

                this.photoSelected = image;
                this.photoTitle = title;
                this.activeSl = sl;
            },
            closeModal(event) {
                this.toggleModal();
            },
        },
        mounted() {
            this.getGallery();
        }
    };
</script>
